import { readUserLocationCookie } from "./cookie";

const getBranchCode = () => {
  const userLocation = readUserLocationCookie();
  return userLocation ? userLocation.branchCode : null;
};

export default getBranchCode;
